import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

const VentureCard = ({ venture, index }) => {
  const isEven = index % 2 === 0;

  return (
    <Card className="overflow-hidden border-none shadow-lg hover:shadow-2xl transition-all duration-500 group">
      <CardContent className="p-0">
        <div className={`flex flex-col ${isEven ? 'md:flex-row' : 'md:flex-row-reverse'} items-stretch`}>
          {/* Image Section */}
          <div className="md:w-1/2 relative overflow-hidden bg-gradient-to-br from-gray-100 to-gray-50">
            <div className="absolute inset-0 bg-[#ffed00]/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            <img
              src={venture.image}
              alt={venture.title}
              className="w-full h-full object-cover min-h-[300px] transform group-hover:scale-105 transition-transform duration-700"
            />
          </div>

          {/* Content Section */}
          <div className="md:w-1/2 p-8 lg:p-12 flex flex-col justify-center">
            <h3 className="text-3xl font-bold mb-3 text-gray-900 group-hover:text-[#ffed00] transition-colors duration-300">
              {venture.title}
            </h3>
            <p className="text-[#ff8385] font-semibold mb-4 text-sm">
              {venture.tagline}
            </p>
            <p className="text-gray-600 leading-relaxed mb-6">
              {venture.description}
            </p>

            {/* Stats */}
            {venture.stats && (
              <div className="grid grid-cols-3 gap-4 mb-6 pb-6 border-b border-gray-200">
                {venture.stats.map((stat, idx) => (
                  <div key={idx} className="text-center">
                    <div className="text-2xl font-bold text-[#ffed00] mb-1">{stat.value}</div>
                    <div className="text-xs text-gray-500">{stat.label}</div>
                  </div>
                ))}
              </div>
            )}

            <a href={venture.link} target="_blank" rel="noopener noreferrer">
              <Button
                variant="outline"
                className="group/btn border-2 border-[#ffed00] text-[#ffed00] hover:bg-[#4eb5e6] hover:text-white font-semibold px-6 py-2 rounded-full transition-all duration-300"
              >
                {venture.buttonText}
                <ArrowRight className="ml-2 h-4 w-4 group-hover/btn:translate-x-1 transition-transform duration-300" />
              </Button>
            </a>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default VentureCard;
